import { render, staticRenderFns } from "./PetitionsReviewPage.vue?vue&type=template&id=6cda9404"
import script from "./PetitionsReviewPage.vue?vue&type=script&lang=js"
export * from "./PetitionsReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports